import { Capacitor } from '@capacitor/core';

/**
 * Check if the app is running on the web platform
 */
export function isPlatformWeb(): boolean {
  return Capacitor.getPlatform() === 'web';
}

/**
 * Check if the app is running on iOS
 */
export function isPlatformIOS(): boolean {
  return Capacitor.getPlatform() === 'ios';
}

/**
 * Check if the app is running on Android
 */
export function isPlatformAndroid(): boolean {
  return Capacitor.getPlatform() === 'android';
}

/**
 * Check if the app is running on a native mobile platform (iOS or Android)
 */
export function isPlatformMobile(): boolean {
  return isPlatformIOS() || isPlatformAndroid();
} 